import type { ElementProps } from "../types";
import S from "./Text.module.scss";

export const Mailtext = ({ template, innerRef }: ElementProps) => {
  return (
    <div
      className={S.mailto}
      contentEditable
      ref={(innerRef as React.RefObject<HTMLDivElement>) ?? undefined}
      dangerouslySetInnerHTML={{ __html: template.text }}
    />
  );
};
